module.exports = __webpack_public_path__ + "static/img/5.407af8a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/3/zh/5.png
// module id = H3ZK
// module chunks = 0